var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-indicator"},[(_vm.show)?_c('div',{staticClass:"content"},[_c('half-circle-spinner',{attrs:{"animation-duration":1000,"size":26,"color":"#ec1d24"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }